import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { BNav, BNavItem } from "bootstrap-vue";
import visualizationsGridConfig from "@/components/Grid/configs/visualizations";
import visualizationsPublishedGridConfig from "@/components/Grid/configs/visualizationsPublished";
import { useUserStore } from "@/stores/userStore";
import Heading from "@/components/Common/Heading.vue";
import LoginRequired from "@/components/Common/LoginRequired.vue";
import GridList from "@/components/Grid/GridList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridVisualization',
    props: {
        activeList: { default: "my" }
    },
    setup(__props) {
        const userStore = useUserStore();
        library.add(faPlus);
        return { __sfc: true, userStore, faPlus, BNav, BNavItem, visualizationsGridConfig, visualizationsPublishedGridConfig, Heading, LoginRequired, GridList };
    }
});
